<div class="dialog-container">
  @if (confirmation.icon) {
    <i class="material-icons">{{ confirmation.icon }}</i>
  }
  <div mat-dialog-content>
    <h1>{{ confirmation.title }}</h1>
    <p [innerHTML]="confirmation.warning | safeHtml"></p>
  </div>
  <div mat-dialog-actions>
    @if (confirmation.isCancelDisplay) {
      <button mat-button mat-stroked-button mat-dialog-close data-testid="dialog-cancel">Cancel</button>
    }
    <button mat-raised-button [mat-dialog-close]="true" name="confirm-btn" color="primary" cdkFocusInitial data-testid="dialog-confirm">
      {{ confirmation.confirmationTitle }}
    </button>
  </div>
</div>
